import { Component, useState } from "react";
import { Link, Routes, Route, BrowserRouter } from "react-router-dom";
import Loading from "./Loading";
import PerSurah from "./perSurah";

class Surah extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      isLoading: true,
    };
  }

  componentDidMount() {
    fetch(
      "https://raw.githubusercontent.com/penggguna/QuranJSON/master/quran.json"
    )
      .then((response) => response.json())
      .then((data) => this.setState({ items: data, isLoading: false }));
  }

  render() {
    const { items, isLoading } = this.state;
    if (isLoading) {
      return <Loading />;
    }

    return (
      <div className="gap">
        <p className="judul"> Daftar Surah di Al-Qur'an </p>
        <div className="row g-0 d-flex justify-content-center">
          {items.map((item, index) => (
            <div className="cards col-3 " key={index}>
              <Link to={`/surah/${item.number_of_surah}`}>
                <div className="surah">
                  <div className="nomor-surah">{item.number_of_surah}</div>
                  <div className="nama-surah">
                    {item.name}
                    <span> ({item.name_translations.ar})</span>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default Surah;
